import { Expose } from 'class-transformer';
import { IsBoolean, IsEnum, IsOptional, IsString } from 'class-validator';
import { Unit, UnitType } from '../../../entities';

export default class CreateUnitInput implements Omit<Unit, 'id' | 'disabled'> {
  @IsString()
  readonly number: string;

  @IsString()
  readonly label: string;

  @IsString()
  @IsOptional()
  readonly size?: string;

  @IsString()
  @Expose({ name: 'condominium_id' })
  readonly condominiumId: string;

  @IsString()
  @Expose({ name: 'section_id' })
  @IsOptional()
  readonly sectionId?: string;

  @IsBoolean()
  @IsOptional()
  readonly disabled?: boolean;

  @IsEnum(UnitType)
  @IsOptional()
  readonly type?: UnitType;

  constructor(init?: CreateUnitInput) {
    this.number = init?.number!;
    this.label = init?.label!;
    this.size = init?.size;
    this.condominiumId = init?.condominiumId!;
    this.sectionId = init?.sectionId;
    this.disabled = init?.disabled;
    this.type = init?.type;
  }
}
